import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const error_notify = (text) => toast.error(text ? text : "Something went wrong", {
    position: toast.POSITION.TOP_CENTER
});
const readerFile = (e) => {
    let reader = new FileReader();
    let file = e.target.files[0] ? e.target.files[0] : {};
    var approvedHTML = "";
    var count = 1;
    var files = e.currentTarget.files; // puts all files into an array
    // call them as such; files[0].size will get you the file size of the 0th file
    // for (var x in files) {

    // var filesize = ((file.size / 1024) / 1024).toFixed(4); // MB

    if (file && file.size <= 575561) {

        reader.readAsDataURL(file);
        return file
    } else {
        error_notify("File is too big!")
    }
    // }
    // $("#approvedFiles").val(approvedHTML);
    // if (file) {
    //     reader.readAsDataURL(file);
    // }
    // reader.onloadend = () => {
    //     image = {
    //         ...image,
    //         value: file,
    //         imagePreviewUrl: reader.result
    //     }
    // }
    // if (file.type.includes("image")) {

    // }
    // this.uploadImage(value)
}
export default readerFile;